import { AccessLevel } from '../../../../types';

export function getVisibleAccessLevelOptions<T extends { value: AccessLevel }>(
    accessLevels: AccessLevel[],
    availableOptions: T[]
): T[] {
    const availableAccessLevelSet = new Set(accessLevels);

    return availableOptions.filter(({ value }) => availableAccessLevelSet.has(value));
}
